import { render, staticRenderFns } from "./lin-dialog.vue?vue&type=template&id=0fbf29e8&scoped=true&"
import script from "./lin-dialog.vue?vue&type=script&lang=js&"
export * from "./lin-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf29e8",
  null
  
)

export default component.exports